<div class="loading-container">
    <div class="point-container">
        <div class="point point-1"></div>
        <div class="point point-2"></div>
        <div class="point point-3"></div>
    </div>
</div>
